import styled from 'styled-components'

export const StyledExternalDiv = styled.div`
  background-color: #f3f5ff;
  width: 70%;
  radius: 4px;
  padding: 14px;
  gap: 4px;
  display: flex;
  flex-direction: row;
  border-radius: 5px;
  align-items: center;
`
